import { detect } from "detect-browser";

const service = (() => {
  // For informational/debugging purpose only
  console.info("BROWSER:", detect());

  const getName = () => {
    let browser = detect();
    return browser.name.toLowerCase();
  };

  return { getName };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/browser.js